export const globalLetterAPIUrls = {
  save: '/settings/global-letter/save',
  fetch: '/settings/global-letter/fetch',
  templates: '/settings/merge',
  mainFirmContacts: '/settings/global-letter/main-firm-contacts',
  emailTemplate: {
    save: '/settings/global-letter/email-template/save',
    fetch: '/settings/global-letter/email-template/fetch',
    delete: '/settings/global-letter/email-template/delete/{id}',
  },
  branding: {
    save: '/settings/global-letter/branding/upload',
    fetch: '/settings/global-letter/branding/images',
    delete: '/settings/global-letter/branding/delete',
  },
} as const;
